module.exports = __webpack_public_path__ + "static/media/address-box.76e43fa8.jpg";